import React from 'react';

interface PatternLineProps {
  isLastLine?: boolean;
  arePatternsDisabled?: boolean;
}

const PatternLine: React.FC<
  React.PropsWithChildren<PatternLineProps>
> = props => {
  const { children, isLastLine, arePatternsDisabled } = props;

  return (
    <>
      {children}
      {!isLastLine && (
        <br {...(!arePatternsDisabled && { 'aria-hidden': true })} />
      )}
    </>
  );
};

export { PatternLine };
